// src/utils/navigation/NavigationUtils.js
import { useNavigate } from 'react-router-dom';

// Logika : Custom hook untuk navigasi
export function useNavigateTo() {
  const navigate = useNavigate();

  function navigateTo(path) {
    navigate(path);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  return navigateTo;
}